import React from "react";
import AuthMethodCard from "../components/AuthMethodCard";
import { AuthMethod } from "../schemas/auth";

interface MethodSelectionProps {
  authMethods: AuthMethod[];
  onSelect: (method: AuthMethod) => void;
  onBack: () => void;
  loading: boolean;
  error: string | null;
}

export default function MethodSelection({
  authMethods,
  onSelect,
  onBack,
  loading,
  error,
}: MethodSelectionProps) {
  return (
    <div>
      <button
        type="button"
        onClick={onBack}
        className="btn btn-link p-0 mb-4 text-muted d-flex align-items-center gap-1"
        aria-label="Go back"
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          aria-hidden="true"
        >
          <polyline points="15 18 9 12 15 6" />
        </svg>
        Back
      </button>

      <h1 className="h3 fw-bold text-dark mb-1">Choose how to sign in</h1>
      <p className="text-muted mb-4">
        Multiple sign-in options are available for your account.
      </p>

      {error && (
        <div className="alert alert-danger py-2 mb-3" role="alert">
          {error}
        </div>
      )}

      <div role="list" aria-label="Available sign-in methods">
        {authMethods.map((method, index) => (
          <div
            key={
              method.type === "password"
                ? "password"
                : method.redirect_url ?? `sso-${index}`
            }
            role="listitem"
          >
            <AuthMethodCard
              method={method}
              onSelect={onSelect}
              disabled={loading}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
